import type { MeetPublicInfo } from './meetApi';

/**
 * The meeting as plain text, for pasting into a chat, an email or a calendar
 * note. Three blocks separated by a blank line so it reads well in WhatsApp:
 *
 *   🚀 Follow-up AI Workshop #6
 *
 *   Marți, 3 noiembrie 2026 la 18:30 · 120 min
 *   organizată de Andrei Pața
 *
 *   Link pentru conectare: https://app.firmio.ro/meet/…
 */
export function meetingDetailsText(
  info: Pick<MeetPublicInfo, 'title' | 'scheduledAt' | 'durationMinutes' | 'hostName'>,
  joinUrl: string,
  t: (key: string, vars?: Record<string, string | number>) => string,
  locale: string,
): string {
  const start = new Date(info.scheduledAt);
  const day = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(start);
  const time = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(
    start,
  );
  const when = t('meet.details.when', { day, time });
  return [
    info.title,
    '',
    `${when.charAt(0).toLocaleUpperCase(locale)}${when.slice(1)} · ${info.durationMinutes} min`,
    t('meet.hostedBy', { name: info.hostName }),
    '',
    t('meet.details.joinLink', { url: joinUrl }),
  ].join('\n');
}
